import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2005',
    ecrans: ['00-2'],
    params: ['id','?dalcleint','?demcleint', '?lemcleint', '?tdlcleint', '?dalnumdoc']
});
